import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchFrontendConfig() {
  try {
    const config = yield call(function() {
      return Api.get('/frontend/config')
    });
    yield put({type: 'FETCH_FRONTEND_CONFIG.SUCCESS', config});
  } catch (error) {
    yield put({type: 'FETCH_FRONTEND_CONFIG.FAILURE', error});
  }
}

export function* watchFetchFrontendConfig() {
  yield takeEvery('FETCH_FRONTEND_CONFIG.REQUEST', fetchFrontendConfig)
}
